import styled from "styled-components"

export interface StyledCardEventProps {
  remove_offset_margin: boolean
}

export interface StyledColorProps {
  category: string
}

export const StyledCardEvent = styled.div`
  width: calc(100% - 48px);
  position: relative;
  padding: 17px 0 48px 0;
  cursor: pointer;

  @media (max-width: ${(props) =>
      props.theme.breakPoints.wide}) and (min-width: ${(props) =>
      props.theme.breakPoints.desktop}) {
    width: 100%;
  }
  @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
    padding: 24px 0;
  }
`

export const StyledCardWrapper = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  padding: 32px;
  position: relative;
  z-index: 1;
  width: 100%;
  box-shadow: 0 0 16px ${(props) => props.theme.colors.darkGrey10};
  height: 100%;
  ${(props) => props.theme.mixins.hoverTransition};
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    padding: 24px;
  }

  &:hover {
    ${(props) => props.theme.mixins.hover};
  }
`

export const StyledCardLink = styled.div`
  width: 100%;
  height: 100%;
  z-index: 10;
  position: absolute;
  top: 0;
  left: 0;
  & a {
    width: 100%;
    height: 100%;
    cursor: pointer;
    position: absolute;
    top: 0;
    left: 0;
    color: transparent;
  }
`

export const StyledText = styled.div`
  min-height: 180px;
  @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
    min-height: 120px;
  }
`

export const StyledDate = styled.div<StyledCardEventProps>`
  ${(props) => props.theme.mixins.h1};
  font-family: ${(props) => props.theme.fonts.circularBold};

  ${(props) =>
    props.remove_offset_margin
      ? `
    margin-top: 0;  
    `
      : `
    margin-top: -56px;
    `}

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    ${(props) =>
      props.remove_offset_margin
        ? `
    margin-top: 0;  
    `
        : `
    margin-top: -42px;
    `}
  }
`

export const StyledTitleWrapper = styled.div`
  padding: 16px 0;
`

export const StyledTitle = styled.div`
  ${(props) => props.theme.mixins.subsectionTitle};
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    font-size: 18px;
  }
`

export const StyledDescWrapper = styled.div`
  ${(props) => props.theme.mixins.body};
  padding-bottom: 24px;
`

export const StyledDesc = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    -webkit-line-clamp: 2;
  }

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    font-size: 14px;
  }
`

export const StyledDegreeContainer = styled.div`
  margin: -4px;
  display: flex;
  flex-wrap: wrap-reverse;
`

export const StyledDegreeItem = styled.div`
  padding: 8px 16px;
  margin: 4px;
  font-family: ${(props) => props.theme.fonts.circularMedium};
  font-size: 14px;
  color: #555;
  background-color: rgba(43, 43, 43, 5%);
  border-radius: 50px;

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    font-size: 12px;
  }
`

export const StyledCategoryContainer = styled.div`
  position: absolute;
  bottom: 0;
  right: -48px;

  @media (max-width: ${(props) =>
      props.theme.breakPoints.wide}) and (min-width: ${(props) =>
      props.theme.breakPoints.desktop}) {
    right: 0;
    bottom: -8px;
    width: calc(100% - 24px);
  }

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    width: auto;
  }
`

export const StyledCategoryShape = styled.div`
  position: relative;
  width: 100%;
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    width: auto;
    display: flex;
    justify-content: flex-end;
  }
  @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
    display: flex;
    justify-content: flex-end;
  }

  & img {
    width: 100%;
    @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
      height: 100%;
      width: auto;
    }
    @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
      aspect-ratio: 1 / 1;
      max-width: 70%;
    }
  }
`

export const StyledCategory = styled.div`
  position: absolute;
  right: 48px;
  display: flex;
  bottom: 48px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;

  @media (max-width: ${(props) =>
      props.theme.breakPoints.wide}) and (min-width: ${(props) =>
      props.theme.breakPoints.desktop}) {
    bottom: 24px;
    right: 0;
    justify-content: center;
  }
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    bottom: 0;
    align-items: center;
  }
`

export const StyledCategoryRotate = styled.div`
  text-transform: uppercase;
  transform: rotate(180deg);
  transform-origin: right;
  writing-mode: vertical-lr;
  white-space: nowrap;
  display: flex;
  padding-right: 8px;
  align-items: center;

  @media (max-width: ${(props) =>
      props.theme.breakPoints.wide}) and (min-width: ${(props) =>
      props.theme.breakPoints.desktop}) {
    transform: rotate(0deg);
    transform-origin: unset;
    writing-mode: unset;
    padding-right: 0;
  }
`

export const StyledCategoryText = styled.p`
  font-family: ${(props) => props.theme.fonts.circularMedium};
  font-size: 14px;
  color: ${(props) => props.theme.colors.white};
  line-height: normal;
  padding-bottom: 8px;
  @media (max-width: ${(props) =>
      props.theme.breakPoints.wide}) and (min-width: ${(props) =>
      props.theme.breakPoints.desktop}) {
    padding-bottom: 0;
    padding-right: 8px;
  }

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    font-size: 12px;
    padding-right: 0;
  }
`

export const StyledIcon = styled.div`
  & img {
    width: 21px;
    transform: rotate(180deg);

    @media (max-width: ${(props) =>
        props.theme.breakPoints.wide}) and (min-width: ${(props) =>
        props.theme.breakPoints.desktop}) {
      transform: rotate(0deg);
    }

    @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
      width: 18px;
    }

    @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
      width: 16px;
    }
  }
`

export const StyledArrow = styled.div<StyledColorProps>`
  padding-left: 16px;
  display: flex;
  justify-content: flex-end;
  & svg {
    ${(props) =>
      props.category === "Virtual Open House" &&
      `
     color: #0E6D63;
     `}
    ${(props) =>
      props.category === "Sample Class" &&
      `
            color: #3A2773;
            `}
      ${(props) =>
      props.category === "Experience Hult" &&
      `
            color: #AF2597;
            `}
  ${(props) =>
      props.category === "Virtual Skills Lab" &&
      `
      color: #AB050F;
      `}
  }
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    padding-top: 0;
  }
`

export const StyledColorWrapper = styled.div<StyledCardEventProps>`
  display: flex;
  justify-content: space-between; 
  align-items: center;
  // flex-direction: column;

  ${(props) =>
    props.remove_offset_margin &&
    `
    // flex-direction: row; 
    // justify-content: space-between; 
    // align-items: center;

    ${StyledArrow}{
      padding-top: 0;
    }
    `}

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`
